module.exports = __webpack_public_path__ + "img/Bunga@3x.3f19bd8f.png";